import Loader from "components/loading/loader";
import { AuthProvider } from "contexts/AuthContext";
import { CollapseDrawerProvider } from "contexts/CollapseDrawerContext";
import { Provider as ReduxProvider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistor, store } from "redux/store";
import Router from "routes";
import ThemeSetter from "./theme/ThemeSetter";

function App() {
  return (
    <AuthProvider>
      <ReduxProvider store={store}>
        <PersistGate loading={<Loader />} persistor={persistor}>
          <CollapseDrawerProvider>
            <ThemeSetter>
              <Router />
            </ThemeSetter>
          </CollapseDrawerProvider>
        </PersistGate>
      </ReduxProvider>
    </AuthProvider>
  );
}

export default App;
